import { useCallback } from 'react';
import cn from 'bem-cn';

import { Prompt } from '@ai-platform/utils';

import backgroundGradient from '../../images/collection-gradient.png';
import backgroundGradientMobile from '../../images/collection-gradient-mobile.png';
import stickersLeft from '../../images/stickers/stickers-1.png';
import stickersRight from '../../images/stickers/stickers-2.png';
import stickersLeftMobile from '../../images/stickers/stickers-1-mobile.png';
import stickersRightMobile from '../../images/stickers/stickers-2-mobile.png';
import { useGetPromptsByIdsQuery } from '../../store';
import { ScreenSize, useGetScreenSize } from '../../hooks';
import { Carousel, ImageWithFadeIn, Stack } from '../UI';

import { renderPrompt, renderPromptSkeleton, skeletonItems } from './Collection.helpers';
import { CollectionProps } from './Collection.types';
import './Collection.scss';

const b = cn('collection');

export const Collection = (props: CollectionProps) => {
    const { className, collection } = props;
    const { id, title, description, promptsIds } = collection;

    const screenSize = useGetScreenSize();
    const isDesktop = screenSize >= ScreenSize.SmallDesktop;

    const keyExtractor = useCallback((prompt: Prompt) => `collection-${id}-prompt-${prompt.id}`, [id]);
    const skeletonKeyExtractor = useCallback((_: unknown, index: number) => `collection-${id}-skeleton-${index}`, [id]);

    const { data: prompts, isFetching } = useGetPromptsByIdsQuery({ promptsIds }, { skip: !promptsIds.length });

    return (
        <div className={b.mix(className)}>
            <Stack direction="row" justifyContent="space-between" className={b('stickers')}>
                <ImageWithFadeIn src={isDesktop ? stickersLeft : stickersLeftMobile} alt="" />
                <ImageWithFadeIn src={isDesktop ? stickersRight : stickersRightMobile} alt="" />
            </Stack>
            <Stack className={b('content')}>
                <div className={b('background')}>
                    <ImageWithFadeIn src={isDesktop ? backgroundGradient : backgroundGradientMobile} alt="" />
                </div>
                <Stack spacing={4} className={b('text-block')}>
                    <h3 className={b('title')}>{title}</h3>
                    <p className={b('description')}>{description}</p>
                </Stack>
                <Carousel
                    className={b('carousel')}
                    isLoading={isFetching}
                    items={prompts || []}
                    renderItem={renderPrompt}
                    keyExtractor={keyExtractor}
                    skeletonItems={skeletonItems}
                    renderSleketonItem={renderPromptSkeleton}
                    skeletonKeyExtractor={skeletonKeyExtractor}
                />
            </Stack>
        </div>
    );
};
